import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Returns a "back" handler that pops real browser history when an in-app entry
 * exists, and otherwise navigates to a safe fallback route (default `/dashboard`)
 * so a deep-link or refresh never navigates the user out of the app.
 *
 * Uses React Router's in-memory `location.key` (which is `'default'` only for the
 * first in-app entry) rather than `window.history.state.idx`, because the auth
 * callback cleanup calls `window.history.replaceState({})` and wipes that index.
 */
export const useSmartBack = (fallback: string = '/dashboard'): (() => void) => {
  const navigate = useNavigate();
  const { key } = useLocation();
  return useCallback(() => {
    if (key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, key, fallback]);
};

export default useSmartBack;
